import React from 'react';
import { StaticTranslator } from '@dp/i18n-web-sdk';

const trans = new StaticTranslator({
  defaultLocale: 'en-US',
  locale: 'en-US',
  project: 'overseas-official-website',
  useBackend: true,
  ns: ['agent_website', 'merchant_website'],
  defaultNS: 'agent_website',
  load: 'currentOnly', // 禁止加载 fallback 语言 (如 zh-CN 回退到 zh)
});

export const withTranslator = (WrappedComponent) => {
  return class withTranslator extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        translator: trans,
        i18nInstance: trans.i18n,
        // 存储当前语言 key，用于触发重渲染
        currentLanguage: trans.i18n.language || 'en-US',
      };
    }

    componentDidMount() {
      // 订阅语言变化事件
      // trans 实例本身实现了事件订阅接口
      if (this.state.i18nInstance) {
        this.state.i18nInstance.on('languageChanged', this.handleLanguageChanged);
      }
    }

    componentWillUnmount() {
      // 取消订阅
      if (this.state.i18nInstance) {
        this.state.i18nInstance.off('languageChanged', this.handleLanguageChanged);
      }
    }

    handleLanguageChanged = (lng) => {
      // 语言变化时更新 state，触发 React 组件重新渲染
      this.setState({ currentLanguage: lng });
    };

    render() {
      // 将 translator 实例通过 props 传递给包裹的组件
      // 这里传递 translator 实例，它包含了 t 函数和其他 helper 方法
      return <WrappedComponent {...this.props} i18n={this.state.translator} />;
    }
  };
};